import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import FinanceReportCard from '../../components/domain/FinanceReportCard'
import FinancePageShell from '../../components/FinancePageShell'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
`

const Reports = () => {
  const navigate = useNavigate()

  const cards = [
    {
      title: 'Trial Balance',
      description:
        'The debit, credit, and net balance for every account from posted entries.',
      path: '/finance/reports/trial-balance',
    },
    {
      title: 'General Ledger',
      description: 'A line-by-line ledger view for posted journal entry lines.',
      path: '/finance/reports/general-ledger',
    },
    {
      title: 'Account Balances',
      description:
        'Current balances by chart-of-accounts classification and account.',
      path: '/finance/reports/account-balances',
    },
    {
      title: 'Expense Register',
      description: 'Review expense document activity and posted outcomes.',
      path: '/finance/reports/expense-register',
    },
    {
      title: 'Top Balances',
      description: 'Quick visibility into high-impact accounts by balance.',
      path: '/finance/reports/top-balances',
    },
    {
      title: 'Cash Flow',
      description: 'Monthly inflow, outflow, and net cash movement summaries.',
      path: '/finance/reports/cash-flow',
    },
    {
      title: 'Invoice Register',
      description:
        'Customer invoices and vendor bills with posted and residual balances.',
      path: '/finance/reports/invoice-register',
    },
    {
      title: 'Payment Register',
      description: 'Inbound and outbound payment activity with open amounts.',
      path: '/finance/reports/payment-register',
    },
    {
      title: 'Partner Balances',
      description: 'Receivable, payable, and net position by finance partner.',
      path: '/finance/reports/partner-balances',
    },
    {
      title: 'Receivable Aging',
      description: 'Outstanding customer balances grouped into aging buckets.',
      path: '/finance/reports/receivable-aging',
    },
    {
      title: 'Payable Aging',
      description: 'Outstanding vendor balances grouped into aging buckets.',
      path: '/finance/reports/payable-aging',
    },
    {
      title: 'Balance Sheet',
      description:
        'Statement of assets, liabilities, and equity. Planned for the next reporting pass.',
      status: 'planned' as const,
      path: '',
      disabled: true,
    },
    {
      title: 'P&L',
      description:
        'Profit and loss summary across posted accounting periods. Planned for the next reporting pass.',
      status: 'planned' as const,
      path: '',
      disabled: true,
    },
  ]

  return (
    <FinancePageShell title="Reports">
      <Grid>
        {cards.map((card) => (
          <FinanceReportCard
            key={card.title}
            title={card.title}
            description={card.description}
            status={card.status || 'live'}
            disabled={card.disabled}
            onClick={() => navigate(card.path)}
          />
        ))}
      </Grid>
    </FinancePageShell>
  )
}

export default Reports
